import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../axiosInstance';
import { errorResponseParser } from '../../utils/handlers';

export const getOtherExpenseType = createAsyncThunk(
  'getOtherExpenseType',
  async (_, { getState, rejectWithValue, dispatch }) => {
    const { userInfo } = getState().auth;
    const { companyId } = userInfo;
    try {
      const response = await axiosInstance.get(`/otherExpenseType`, {
        params: {
          companyId: companyId,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

export const getOtherExpenseTypeList = createAsyncThunk(
  'getOtherExpenseTypeList',
  async (data, { getState, rejectWithValue, dispatch }) => {
    const { userInfo } = getState().auth;
    const { employeeId, companyId } = userInfo;
    try {
      const response = await axiosInstance.get(`/otherExpenseTypeList`, {
        params: {
          expenseId: data?.expenseId,
          employeeId: employeeId,
          activityDate: data?.activityDate,
          companyId: companyId,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

export const saveOtherExpenseType = createAsyncThunk(
  'saveOtherExpenseType',
  async (data, { getState, rejectWithValue, dispatch }) => {
    const { userInfo } = getState().auth;
    const { employeeId , companyId } = userInfo;
    try {
      const response = await axiosInstance.post(`/otherExpenseTypeSave`, {
        ...data,
        companyId: companyId,
        employeeId : employeeId
      },{
        headers: {
          "Content-Type": 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

//deleteUploadExpenseBill
export const deleteOtherExpenseType = createAsyncThunk(
  'deleteOtherExpenseType',
  async (payload, { getState, rejectWithValue, dispatch }) => {
    const { userInfo } = getState().auth;
    const { companyId } = userInfo;
    try {
      const response = await axiosInstance.delete(`/otherExpenseTypeDelete`, {
        params: {
          id: payload?.id,
          expenseId: payload?.expenseId,
          activityDate: payload?.activityDate,
          companyId: companyId
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

export const otherExpenseBill = createSlice({
  name: 'otherExpenseBill',
  initialState: {
    otherExpenseType: [],
    isOtherExpenseAttachmentDetails: {},
    otherExpenseList: [],
    isOtherExpenseTypeSubmitted: false,
    isOtherExpenseDeleted: false
  },
  reducers: {
    resetOtherExpenseSubmitted: (state) => {
      state.isOtherExpenseTypeSubmitted = false;
    },
    resetOtherExpenseDeleted: (state) => {
      state.isOtherExpenseDeleted = false;
    },
    selectOtherExpenseBillAttachment: (state, action) => {
      state.isOtherExpenseAttachmentDetails = action.payload;
    },
  },
  extraReducers: (builder) => {
    //getOtherExpenseType
    builder
      .addCase(getOtherExpenseType.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOtherExpenseType.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.otherExpenseType = payload;
      })
      .addCase(getOtherExpenseType.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
        state.apiError = true;
      });

    //getOtherExpenseTypeList
    builder
      .addCase(getOtherExpenseTypeList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOtherExpenseTypeList.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.otherExpenseList = payload;
      })
      .addCase(getOtherExpenseTypeList.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
        state.apiError = true;
      });

    //saveOtherExpenseType
    builder
      .addCase(saveOtherExpenseType.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(saveOtherExpenseType.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isOtherExpenseTypeSubmitted = true;
      })
      .addCase(saveOtherExpenseType.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
        state.apiError = true;
      });

      //otherExpenseDeleted
    builder
      .addCase(deleteOtherExpenseType.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteOtherExpenseType.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isOtherExpenseDeleted = true;
      })
      .addCase(deleteOtherExpenseType.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
        state.apiError = true;
      });
  },
});

export const { selectOtherExpenseBillAttachment, resetOtherExpenseSubmitted, resetOtherExpenseDeleted } =
  otherExpenseBill.actions;
export const otherExpenseBillReducer = otherExpenseBill.reducer;
